module.exports = __webpack_public_path__ + "HSA Insert.pdf";